import { render, staticRenderFns } from "./CreateStaff.vue?vue&type=template&id=670a8f66&scoped=true"
import script from "./CreateStaff.vue?vue&type=script&lang=js"
export * from "./CreateStaff.vue?vue&type=script&lang=js"
import style0 from "./CreateStaff.vue?vue&type=style&index=0&id=670a8f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a8f66",
  null
  
)

export default component.exports